import { Link } from "react-router-dom";
import { ArrowUpRight, Compass } from "lucide-react";

import { Container } from "@/platform/layout/container";
import { Badge } from "@/platform/ui/badge";
import { Button } from "@/platform/ui/button";
import { Blob, SoftStar } from "@/platform/ui/illustrations/blobs";

export function NotFoundPage() {
  return (
    <div className="relative overflow-hidden bg-mesh">
      <Blob
        color="violet"
        className="pointer-events-none absolute -left-32 -top-20 w-96 opacity-30 blur-2xl animate-blob"
      />
      <Blob
        color="coral"
        className="pointer-events-none absolute -right-32 bottom-0 w-96 opacity-25 blur-2xl animate-blob"
      />
      <SoftStar
        color="yellow"
        className="pointer-events-none absolute right-12 top-24 w-12 opacity-60 animate-float"
      />

      <Container size="default" className="relative flex min-h-[calc(100vh-56px)] flex-col items-start justify-center py-20">
        <div className="animate-fade-up max-w-2xl">
          <p
            data-tabular="true"
            className="font-display text-[clamp(6rem,18vw,12rem)] font-bold leading-none tracking-[-0.06em] text-gradient-accent"
          >
            404
          </p>
          <Badge variant="pink" className="mt-4 w-fit">
            <Compass className="size-3" aria-hidden />
            Página não encontrada
          </Badge>
          <h1 className="mt-5 font-display text-[length:var(--text-display-md)] font-semibold leading-[var(--text-display-md--line-height)] tracking-[var(--text-display-md--letter-spacing)] text-balance">
            Esse caminho não leva a lugar nenhum.
          </h1>
          <p className="mt-4 text-[length:var(--text-body-lg)] text-[color:var(--color-muted-foreground)] leading-[var(--text-body-lg--line-height)] text-pretty">
            O endereço que você procura não existe ou foi movido. Volte para o início e siga o
            método a partir da página de visão.
          </p>
          <div className="mt-8 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
            <Button asChild size="xl" variant="gradient">
              <Link to="/">
                Voltar para o início
                <ArrowUpRight className="size-4" aria-hidden />
              </Link>
            </Button>
            <Button asChild size="xl" variant="outline">
              <Link to="/metodo">Ver método</Link>
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
